export class Address {
    constructor(lat, lon, street, postalCode, photo) {
        this.lat = parseFloat(lat);
        this.lon = parseFloat(lon);
        this.street = street;
        this.postalCode = postalCode;
        this.photo = photo;
    }
}